<div id="order-search" class="office-page">
    <section class="section-content searching-result">
        <order-search-filter-not-login [page]="page" [len]="len" [reload]="reload" (search)="handleOnSearch($event);">
        </order-search-filter-not-login>
        <order-search-grid-not-login [len]="len" [page]="page" (changeLen)="handleOnChangeLen($event)"
            (changePage)="handleOnChangePage($event)" (resetReload)="handleOnResetReload($event)"></order-search-grid-not-login>
    </section>
</div>